<div class="d-flex font-size-12 mb-1" cvLocalizedText langSection="Wallboard_Slideout" langKey="Show_Slide_For">Show Slide For</div>
<span class="d-flex font-size-12 mb-4" style="gap: 16px;">
    <input class="form-control form-control-m" type="text" placeholder="0 Minutes" maxlength="2"
           [(ngModel)]="minValue" (ngModelChange)="calculateSlideDuration()" (keypress)="cleanKeyPress($event)" (paste)="onPaste($event)"
           (focusout)="setGeneralSettingsDisplay()" cvLocalizedPlaceholder langSection="Wallboard_Slideout" langKey="Minutes_Placeholder"/>
    <input class="form-control form-control-m" type="text" placeholder="30 Seconds" maxlength="2"
           [(ngModel)]="secValue" (ngModelChange)="calculateSlideDuration()" (keypress)="cleanKeyPress($event)" (paste)="onPaste($event)"
           (focusout)="setGeneralSettingsDisplay()" cvLocalizedPlaceholder langSection="Wallboard_Slideout" langKey="Seconds_Placeholder"/>
</span>

<div class="mb-2" *ngIf="settingsToUse">
    <div class="d-flex mb-3">{{generalSettingsDisplayText}}</div>
    <div class="d-flex mb-3" *ngIf="settingsToUse.SettingBackgroundShadow">
        <input type="checkbox" class="form-check-input ml-2 my-auto" [(ngModel)]="settingsManager.generalWallboardSettings.UseBackdrop" (ngModelChange)="setGeneralSettingsDisplay()"/>
        <span class="ml-2 background-shadow-tooltip" cvLocalizedText langSection="Wallboard_Slideout" langKey="Show_Backdrop">Show Backdrop on Slide</span>
        <div class="ml-2" [ngbTooltip]="backdropTooltip" placement="bottom" triggers="mouseenter:mouseleave">
            <svg class="icon-16 fill-valyrianSteel fill-hover-panther icon-btn">
                <use href="../App_Themes/clearview-default/icons/utility/support.svg#support"></use>
            </svg>
        </div>
    </div>
    <div class="d-flex mb-3" *ngIf="settingsToUse.SettingShowTitle">
        <input type="checkbox" class="form-check-input ml-2 my-auto" [(ngModel)]="settingsManager.generalWallboardSettings.ShowTitle" (ngModelChange)="setGeneralSettingsDisplay()"/>
        <span class="ml-2" cvLocalizedText langSection="Wallboard_Slideout" langKey="Show_Title">Show Title on Slide</span>
    </div>
    <div class="d-flex mb-3" *ngIf="settingsToUse.SettingUsePagination">
        <input type="checkbox" class="form-check-input ml-2 my-auto" [(ngModel)]="settingsManager.generalWallboardSettings.UsePagination" (ngModelChange)="setGeneralSettingsDisplay()"/>
        <span class="ml-2" cvLocalizedText langSection="Wallboard_Slideout" langKey="Use_Pagination">Use Pagination</span>
        <div class="ml-2" [ngbTooltip]="paginationDisclaimerText" placement="bottom" triggers="mouseenter:mouseleave">
            <svg class="icon-16 fill-valyrianSteel fill-hover-panther icon-btn">
                <use href="../App_Themes/clearview-default/icons/utility/support.svg#support"></use>
            </svg>
        </div>
    </div>
    <div class="d-flex mb-3" *ngIf="settingsToUse.SettingShowTotalsRow">
        <input type="checkbox" class="form-check-input ml-2 my-auto" [(ngModel)]="settingsManager.generalWallboardSettings.UseTotalsRow" (ngModelChange)="setGeneralSettingsDisplay()"/>
        <span class="ml-2" cvLocalizedText langSection="Wallboard_Slideout" langKey="Show_Totals">Show Totals Row</span>
    </div>
    <div class="d-flex mb-2" *ngIf="settingsToUse.SettingShowRanking">
        <input type="checkbox" class="form-check-input ml-2 my-auto" [(ngModel)]="settingsManager.generalWallboardSettings.ShowRanking" (ngModelChange)="setGeneralSettingsDisplay()"/>
        <span class="ml-2" cvLocalizedText langSection="Wallboard_Slideout" langKey="Show_Ranking">Show Ranking</span>
    </div>
</div>

<ng-template #backdropTooltip>
    <div class="font-size-12 text-left" style="width: 232px; margin: 12px 10px;">
        <div class="mb-3" cvLocalizedText langSection="Wallboard_Slideout" langKey="Backdrop_Visibility">This will toggle visibility on the current slide's backdrop container.</div>
        <div class="mb-3">
            <div class="d-flex justify-content-between mb-2">
                <span style="width: 100px;" cvLocalizedText langSection="Wallboard_Slideout" langKey="On">On</span>
                <span style="width: 100px;" cvLocalizedText langSection="Wallboard_Slideout" langKey="Off">Off</span>    
            </div>
            <div class="d-flex justify-content-between">
                <div><img src="../App_Themes/Standard/Images/Wallboards/toggle-example-on.svg" /></div>
                <div><img src="../App_Themes/Standard/Images/Wallboards/toggle-example-off.svg" /></div>
            </div>
        </div>
        <div>
            <div class="mb-2" cvLocalizedText langSection="Wallboard_Slideout" langKey="Lighter_Backgrounds">Best turned on with lighter backgrounds</div>
            <div class="d-flex justify-content-between" style="margin-left: -5px;">
                <div><img src="../App_Themes/Standard/Images/Wallboards/table-background-visible.svg" /></div>
                <div><img src="../App_Themes/Standard/Images/Wallboards/table-background-not-visible.svg" /></div>
            </div>
        </div>
    </div>
</ng-template>
